import { render, staticRenderFns } from "./ModuleSelection.vue?vue&type=template&id=73593202&scoped=true&"
import script from "./ModuleSelection.vue?vue&type=script&lang=ts&"
export * from "./ModuleSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleSelection.vue?vue&type=style&index=0&id=73593202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73593202",
  null
  
)

export default component.exports